import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { apiGet, apiSend } from '../perps-v1-shared/api';

// Candidate pool item — symbols eligible to be pinned. No volume/change fields (v2 has none).
export interface PinCandidate {
  id: string;
  symbol: string;
  displaySymbol: string;
  dex: string;
}

// A pin as persisted for a given view, in order.
export interface Pin {
  id: string;
  symbol: string;
  sortIndex: number;
  // Backend spec INERTPIN: true when the symbol is in the view's interpreted result right now, so
  // the pin actually promotes something. False means the pin is stored and saves fine but has no
  // effect — most commonly a symbol pinned ahead of a rule/includeSymbols change that hasn't
  // landed yet, or a symbol that has since delisted or vanished from the universe.
  isInView: boolean;
}

// getList -> GET /perps-v1/pins/candidates (fetch the full candidate pool once; search filters client-side)
export class PerpsV1PinsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, _params: GetListParams): Promise<any> {
    if (resource !== Resources.perpsV1Pins) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const json = await apiGet<{ data: PinCandidate[]; total: number }>(
      '/perps-v1/pins/candidates?page=1&size=1000'
    );
    return { data: json?.data ?? [], total: json?.total ?? json?.data?.length ?? 0 };
  }
}

export const perpsV1PinsDataProvider = new PerpsV1PinsDataProvider();

export const pinsApi = {
  list: (viewCode: string) =>
    apiGet<{ data: Pin[] }>(`/perps-v1/pins?viewCode=${encodeURIComponent(viewCode)}`),
  save: (viewCode: string, pinned: string[]) =>
    apiSend<{ data: Pin[] }>('/perps-v1/pins', 'PUT', { viewCode, pinned }),
  remove: (viewCode: string, symbol: string) =>
    apiSend<{ data: unknown }>('/perps-v1/pins', 'DELETE', { viewCode, symbol }),
};
